import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Subproces } from '../types/Subproces'

export { createSubprocesForEntity }

const createSubprocesForEntity = async ({
  entity: { type, id },
  subprocesInfo,
}: {
  entity: Entity
  subprocesInfo: Partial<Subproces>
}) => {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/subproces`,
    method: 'POST',
    data: subprocesInfo,
  })

  return data
}
